import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const FARM_TYPES = [
  { value: 'crop',      label: 'Tarla / Tahıl' },
  { value: 'orchard',   label: 'Bahçe / Meyve' },
  { value: 'livestock', label: 'Hayvancılık' },
  { value: 'mixed',     label: 'Karma' },
];

const CITIES = [
  'Adana','Ankara','Antalya','Bursa','Çorum','Diyarbakır','Erzurum',
  'Gaziantep','İstanbul','İzmir','Kahramanmaraş','Kayseri','Konya',
  'Malatya','Mersin','Ordu','Samsun','Şanlıurfa','Trabzon','Van', 'Diğer'
];

export default function RegisterPage() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    farmName: '', ownerName: '', email: '', password: '',
    phone: '', city: '', farmType: 'mixed',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      return toast.error('Şifre en az 6 karakter olmalı');
    }
    setLoading(true);
    try {
      await register(form);
      localStorage.setItem('teldolap_onboarding_pending', 'true');
      toast.success('Hesabınız oluşturuldu! Hoş geldiniz 🌱');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Kayıt başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <span className="logo-icon">🌱</span>
          <h1>Teldolap</h1>
          <p>Yeni hesap oluştur</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.farmName')} *</label>
            <input
              value={form.farmName}
              onChange={e => set('farmName', e.target.value)}
              placeholder="Örn: Aydın Ailesi Çiftliği"
              required
            />
          </div>
          <div className="form-group">
            <label>{t('auth.ownerName')} *</label>
            <input
              value={form.ownerName}
              onChange={e => set('ownerName', e.target.value)}
              placeholder="Adınız Soyadınız"
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>{t('auth.phone')}</label>
              <input
                type="tel"
                value={form.phone}
                onChange={e => set('phone', e.target.value)}
                placeholder="05XX..."
              />
            </div>
            <div className="form-group">
              <label>{t('auth.city')}</label>
              <select value={form.city} onChange={e => set('city', e.target.value)}>
                <option value="">Seçin</option>
                {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>{t('auth.farmType')}</label>
            <select value={form.farmType} onChange={e => set('farmType', e.target.value)}>
              {FARM_TYPES.map(ft => (
                <option key={ft.value} value={ft.value}>{ft.label}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>{t('auth.email')} *</label>
            <input
              type="email"
              value={form.email}
              onChange={e => set('email', e.target.value)}
              placeholder="ornek@mail.com"
              required
            />
          </div>
          <div className="form-group">
            <label>{t('auth.password')} *</label>
            <input
              type="password"
              value={form.password}
              onChange={e => set('password', e.target.value)}
              placeholder="En az 6 karakter"
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '13px' }}
            disabled={loading}
          >
            {loading ? 'Kaydediliyor...' : t('auth.registerButton')}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem', color: '#7a9472' }}>
          {t('auth.hasAccount')}{' '}
          <Link to="/login" style={{ color: '#2d5a27', fontWeight: 700 }}>
            {t('auth.login')}
          </Link>
        </p>
      </div>
    </div>
  );
}
